export default "__VITE_ASSET__506386a8__"